// Consent document versions for marketing/PHI (not calculator terms — those come from the API).
export const MARKETING_CONSENT_VERSION = 'v1-2026-07-31';
export const PHI_ATTESTATION_VERSION = 'v1-2026-07-31';
